import { Layout, LayoutProps } from 'react-admin';
import { MomentsAppBar } from './AdminAppBar';
import { AdminMenu } from './AdminMenu';

export const AdminLayout = (props: LayoutProps) => (
  <Layout {...props} menu={AdminMenu} appBar={MomentsAppBar} />
);
